import { useIntl } from 'react-intl';

import { FormsDrawer } from '@src/components/Form/FormsDrawer';
import { TriggersDrawer } from '@src/components/Triggers/TriggersDrawer';

import { useEventsByScheduleContext } from '../../contexts/EventsByScheduleContext';
import { DelaysDrawer } from '../Shared/DelaysDrawer';
import { UsersTableDrawer } from '../Shared/UsersTableDrawer';

export const DashboardDrawers = () => {
  const intl = useIntl();
  const { drawerActions, DRAWER_TYPES, activeDrawer } = useEventsByScheduleContext();
  return (
    <>
      <UsersTableDrawer
        isVisible={activeDrawer?.type === DRAWER_TYPES.USERS}
        onCancel={() => drawerActions?.close()}
        users={activeDrawer?.data || []}
      />
      <TriggersDrawer
        open={activeDrawer?.type === DRAWER_TYPES.EVENTS}
        onClose={() => drawerActions?.close()}
        title={intl.formatMessage({ id: 'dashboards.events.title' })}
        dataSource={activeDrawer?.data || []}
      />
      <FormsDrawer
        open={activeDrawer?.type === DRAWER_TYPES.FORMS}
        onClose={() => drawerActions?.close()}
        dataSource={activeDrawer?.data || []}
      />
      <DelaysDrawer
        open={activeDrawer?.type === DRAWER_TYPES.DELAYS}
        onClose={() => drawerActions?.close()}
        divisionId={activeDrawer?.data?.divisionId}
        executionId={activeDrawer?.data?.executionId}
      />
    </>
  );
};
